import React from 'react';
import { Switch } from '@mui/material';
import { IResultsType } from '../../types/spreadsheet-types';
import { styled } from '@mui/system';

interface SpreadsheetCorrectedNormalizedProps {
  resultsType: IResultsType;
  setResultsType: (string: IResultsType) => void;
}

const DivTableFootSwitcher = styled('div')({});

const SpanDataTypeSwitchLabel = styled('span')({
  paddingLeft: '3px',
  cursor: 'pointer',
  fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
  fontSize: '12px',
  lineHeight: 1,
});

const SpreadsheetCorrectedNormalized: React.FC<SpreadsheetCorrectedNormalizedProps> = ({
  resultsType,
  setResultsType,
}) => {
  const setResultsTypeCorrected = () => {
    setResultsType('corrected');
  };

  const setResultsTypeNormalized = () => {
    setResultsType('normalized');
  };

  const changeResultsType = () => {
    if (resultsType === 'normalized') {
      setResultsType('corrected');
    } else {
      setResultsType('normalized');
    }
  };

  return (
    <DivTableFootSwitcher>
      <SpanDataTypeSwitchLabel onClick={setResultsTypeCorrected}>
        Corrected
      </SpanDataTypeSwitchLabel>
      <Switch
        onChange={changeResultsType}
        checked={resultsType === 'normalized'}
        value={!resultsType}
        size="small"
        color="primary"
        data-cy="switch-spreadsheet-results-type"
      />
      <SpanDataTypeSwitchLabel onClick={setResultsTypeNormalized}>
        Normalized
      </SpanDataTypeSwitchLabel>
    </DivTableFootSwitcher>
  );
};

export default SpreadsheetCorrectedNormalized;
